import React, { useEffect, useState } from 'react';

import Welcome from './Welcome/Welcome';
import { useAppSelector } from '../../../app/hooks';
import { selectFailedGmailConnection } from '../../../features/ui/uiSlice';
import MissingScopes from './MissingScopes/MissingScopes';
import ConnectGmailPrompt from '../../ConnectGmailPrompt/ConnectGmailPrompt';
import SelectProvider from './SelectProvider/SelectProvider';
import { useLiveQuery } from 'dexie-react-hooks';
import { useGetMailboxData } from '../../../app/useGetMailboxData';
import Mailbox, { getCurrentMailboxQuery } from '../../../model/mailbox';
import { LandingPageFlavorEnum } from './Welcome/welcomeFlavors.types';
import { EventName } from '../../../services/analytics/providers/analyticsProvider';
import AnalyticsService from '../../../services/analytics/analyticsService';

export type OnboardingFlowProps = {
  landingPageFlavor: LandingPageFlavorEnum;
};

function OnboardingFlow(props: OnboardingFlowProps) {
  const { landingPageFlavor } = props;

  const [onboardingStep, setOnboardingStep] = useState<'WELCOME' | 'SIGN_IN'>('WELCOME');

  const failedGmailConnection = useAppSelector(selectFailedGmailConnection);

  const mailbox: Mailbox | undefined | null = useLiveQuery(getCurrentMailboxQuery);
  const { hasTokenAndUserInfoScopes } = useGetMailboxData(mailbox);

  const firstName = mailbox?.first_name;
  const email = mailbox?.email_address;

  useEffect(() => {
    if (onboardingStep === 'WELCOME') {
      if (hasTokenAndUserInfoScopes) {
        setOnboardingStep('SIGN_IN');
      }
    }
  }, [hasTokenAndUserInfoScopes, onboardingStep]);

  useEffect(() => {
    if (onboardingStep === 'WELCOME') {

      AnalyticsService.track(EventName.GET_STARTED_VISIT);
    } else if (onboardingStep === 'SIGN_IN') {
      AnalyticsService.track(EventName.VIEW_PROVIDERS_VISIT);
    }
  }, [onboardingStep]);

  if (onboardingStep === 'WELCOME') {
    return (
      <Welcome
        next={() => {
          setOnboardingStep('SIGN_IN');
        }}
        landingPageFlavor={landingPageFlavor}
        showSignInNext={true}
      ></Welcome>
    );
  } else {
    if (hasTokenAndUserInfoScopes && firstName) {
      if (failedGmailConnection) {
        return <MissingScopes></MissingScopes>;
      } else {
        return <ConnectGmailPrompt firstName={firstName} email={email}></ConnectGmailPrompt>;
      }
    } else {
      return <SelectProvider></SelectProvider>;
    }
  }
}

export default OnboardingFlow;
